import { render, staticRenderFns } from "./DevInfo.vue?vue&type=template&id=0d360188&scoped=true"
import script from "./DevInfo.vue?vue&type=script&lang=js"
export * from "./DevInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d360188",
  null
  
)

export default component.exports